import type { LoadableType } from '@confluence/loadable';
import { LoadableBackground } from '@confluence/loadable';
import type { ShortcutType } from './ShortcutListener.ts';

export const GeneralShortcutListener: LoadableType<{
	accelerator: string | string[];
	deprecatedAccelerator?: string | string[];
	listener(e: KeyboardEvent): void;
	isAppNavigationShortcut?: boolean;
	shortcutType?: ShortcutType;
	allowInDialog?: boolean;
}> = LoadableBackground({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-GeneralShortcutListener" */ '../src/GeneralShortcutListener.tsx'
			)
		).GeneralShortcutListener,
});
